import { zodResolver } from "@hookform/resolvers/zod";
import {
    Box,
    CircularProgress,
    Grid,
    TextField,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { t } from "i18next";
import { useForm } from "react-hook-form";
import { z } from "zod";
import BasicDialog from "../../components/base/BasicDialog";
import { useToasts } from "../../hooks/useToasts";
import toast from "react-hot-toast"
import { SnackbarSuccess } from "../../components/base/SnackbarAlert/SnackbarSuccess";

import { useCreateBankMutation } from "../../services/bankingService";

export const bankFormSchema = z
    .object({
        bank_name: z.string().optional().nullable(),
        active: z.boolean().optional().nullable(),
    })


export function AddBankDialog(props) {
    const { handleSubmit, control, formState, register, reset, setValue, watch } = useForm({
        resolver: zodResolver(bankFormSchema),
        defaultValues: {},
    });

    const { onFormErrors, onServerError } = useToasts();

    const { mutate: addBank, isFetching } = useCreateBankMutation({
        onSuccess: () => {
            toast.custom(
                () => <SnackbarSuccess message={t("successfullyAdded")} />,
                {
                    position: "bottom-right",
                },
            );
            props.onClose()
        },
        onError: (error) => {
            onServerError(error);
        },
    });

    const onSubmit = (data) => {
        addBank({data:data})
    };

    if (isFetching) {
        return (
            <BasicDialog
                open={props.open}
                onClose={props.onClose}
                titleAlign={"center"}
                contentAlign={"center"}
                title="Loading..."
                maxWidth={"xs"}
                showDialogActions
                alwaysFullScreen={false}
            >
                <Box display="flex" justifyContent="center" p={4}>
                    <CircularProgress />
                </Box>
            </BasicDialog>
        );
    }

    return (
        <BasicDialog
            open={props.open}
            onClose={props.onClose}
            titleAlign={"center"}
            contentAlign={"center"}
            showTitle={true}
            title={t("bankings.add_bank")}
            maxWidth={"sm"}
            
        >
            <Grid container >
                <Grid item xs={12}>
                    <TextField
                        {...register("bank_name")}
                        fullWidth
                        disabled={false}
                        label={t("bankings.bank_name")}
                        size="small"
                        sx={{background: "white"}}
                    />
                </Grid>
                <Grid item xs={12}>
                    <LoadingButton
                        loading={isFetching}
                        disabled={false}
                        variant="contained"
                        color="primary"
                        sx={{ mt: 2 }}
                        onClick={handleSubmit(onSubmit, onFormErrors)}
                        fullWidth
                    >
                        {t("bankings.add")}
                    </LoadingButton>
                </Grid>
            </Grid>
        </BasicDialog>
    );
}
